export default "__VITE_ASSET__$$dXdTYg__"